import { Box, Drawer, List, ListItem } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import logo_b from "../../assets/images/logo_b.png";
import { Stack, useScrollTrigger } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { navMenus, routes } from "../../utils/routes";
import DrawerMenu from "./Drawer";
import { Fragment, useState } from "react";
import { styles } from "../../assets/styles";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";

function Header(props) {
  const { window, isHomepage } = props;
  const { pathname } = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setMobileOpen(open);
  };

  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 50,
  });
  const getColorWithRoutes = (isHomepage, trigger, isCurrentPath) => {
    if (isHomepage) {
      // On homepage: keep menu text black at top (logo remains blue)
      return "#000000";
    } else if (isCurrentPath) {
      return "var(--primary-color)";
    } else {
      return "inherit";
    }
  };

  return (
    <Box
      sx={{
        ...styles.headerCont,
        boxShadow: isHomepage
          ? !trigger
            ? "0px 0px 2px #f6fcfc"
            : "0px 4px 8px rgba(0, 0, 0, 0.1)"
          : "0px 4px 8px rgba(0, 0, 0, 0.1)",
        background: isHomepage ? (trigger ? "#fff" : "transparent") : "#fff",
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{ ...styles.pageLayout, py: { xs: 1, sm: 0 } }}
      >
        <IconButton
          onClick={handleDrawerToggle(true)}
          sx={{
            display: { sm: "none" },
            pl: 2,
            color: getColorWithRoutes(isHomepage, trigger, false),
          }}
        >
          <MenuIcon fontSize="inherit" />
        </IconButton>
        <Link to={routes.home}>
          <Box
            sx={{
              ...styles.logoWrapper,
              color: "#000dc1",
            }}
          >
            <Box sx={{ ...styles.logoCont }}>
              <img src={logo_b} alt="Briozon-Logo" />
            </Box>
            Briozon
          </Box>
        </Link>

        <Box sx={{ visibility: "hidden" }}>Text</Box>

        <List
          sx={{
            display: { xs: "none", sm: "flex" },
            py: 0.5,
          }}
        >
          {navMenus.map((menu) => {
            let isHome = menu.route === "/";
            let isCurrentPath;

            if (!isHome) {
              isCurrentPath = pathname.startsWith(menu.route);
            }
            return (
              <Fragment key={menu.name}>
                {menu.children ? (
                  <ListItem
                    className="hasSubmenu"
                    sx={{
                      ...styles.menuItem,
                      pr: 0,
                      "& .navlink": {
                        ...styles.hoverBottomLine,
                        py: 1,
                        color: getColorWithRoutes(
                          isHomepage,
                          trigger,
                          isCurrentPath
                        ),
                      },
                    }}
                  >
                    <Box sx={{ ...styles.flexCenter }}>
                      <Link className="navlink" to={menu.route}>
                        {menu.name}
                      </Link>

                      <ArrowDropUpRoundedIcon
                        sx={{
                          ...styles.menuArrowIcon,

                          color: getColorWithRoutes(
                            isHomepage,
                            trigger,
                            isCurrentPath
                          ),
                        }}
                      />
                    </Box>
                    <List className="submenuCont" sx={styles.subMenuCont}>
                      {menu.children.length > 3 ? (
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns:
                              "repeat(2, minmax(150px, 1fr))",
                            columnGap: 2,
                            minWidth: "200px",
                          }}
                        >
                          {menu.children.map((childMenu, index) => {
                            let isCurrentChildPath =
                              pathname === childMenu.route;
                            return (
                              <ListItem
                                key={childMenu.name}
                                sx={{
                                  ...styles.subMenuItem,
                                  color: isCurrentChildPath
                                    ? "var(--primary-color)"
                                    : "inherit",
                                }}
                              >
                                <Link to={childMenu.route}>
                                  {childMenu.name}
                                </Link>
                              </ListItem>
                            );
                          })}
                        </Box>
                      ) : (
                        <>
                          {menu.children.map((childMenu, index) => {
                            let isCurrentChildPath =
                              pathname === childMenu.route;
                            return (
                              <ListItem
                                key={childMenu.name}
                                sx={{
                                  ...styles.subMenuItem,
                                  color: isCurrentChildPath
                                    ? "var(--primary-color)"
                                    : "inherit",
                                }}
                              >
                                <Link to={childMenu.route}>
                                  {childMenu.name}
                                </Link>
                              </ListItem>
                            );
                          })}
                        </>
                      )}
                    </List>
                  </ListItem>
                ) : (
                  <ListItem
                    sx={{
                      ...styles.menuItem,
                      "& .navlink": {
                        ...styles.hoverBottomLine,
                        color:
                            isHome && pathname === "/"
                              ? !trigger
                                ? "#000000"
                                : "var(--primary-color)"
                              : getColorWithRoutes(
                                isHomepage,
                                trigger,
                                isCurrentPath
                              ),
                      },
                    }}
                  >
                    <Link to={menu.route} className="navlink">
                      {menu.name}
                    </Link>
                  </ListItem>
                )}
              </Fragment>
            );
          })}
        </List>
      </Stack>

      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle(false)}
        sx={{
          ...styles.menuSideBar,
        }}
      >
        {/* {drawer} */}
        <DrawerMenu setMobileOpen={setMobileOpen} />
      </Drawer>
    </Box>
  );
}

export default Header;
